
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.63 20.462A1.539 1.539 0 0119.092 22H5.245a1.539 1.539 0 01-1.538-1.538V3.538A1.538 1.538 0 015.245 2h7.693l7.692 7.692v10.77z","stroke":"#545C69","stroke-width":"1.044","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.938 2v7.692h7.692","stroke":"#545C69","stroke-width":"1.044","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    